<template>
  <div class="casino-group-container casino-user-game-section-container">
    <casino-tabs :section="'userSection'" @tabChanged="onTabChange"></casino-tabs>
    <div v-if="!data || data.games.length === 0" class="no-games-in-list">{{$t('Casino.No.Games')}}</div>
    <div v-if="data && data.games && data.games.length > 0" :data-gid="dataId" class="slider-container" :id="'slider-container-' + dataId">
      <div class="group-header">
        <div v-if="showHideSeeAll" class="see-all"><router-link :to="{ name: 'casino-page', params: { slug: slugMap[section] }}">{{$t('Casino.See.All')}}</router-link></div>
      </div>
      <casino-slider @showHideSeeAll="updateSeeAllStatus" :section="section" :group="groupSliderItemLimit" :gamesByGroup="filteredGames" :key="componentKey"></casino-slider>
    </div>
  </div>
</template>
<script>
import CasinoTabs from '@/components/igaming/partials/casinoTabs.vue'
import CasinoSlider from '@/components/igaming/partials/casinoSlider.vue'
import Casino from '@/components/mixins/Casino'
import store from '@/store'

export default {
  name: 'casinoUserGameSection',
  props: [],
  mixins: [
    Casino
  ],
  components: {
    CasinoTabs,
    CasinoSlider
  },
  data () {
    return {
      dataId: Math.floor(Math.random() * 100),
      section: false,
      showHideSeeAll: true,
      componentKey: false,
      data: false,
      methodMap: {
        'RecentlyPlayed': 'fetchUserRecentlyPlayedGames',
        'RecommendedGames': 'fetchRecommendedGames',
        'FavoriteGames': 'fetchAllFavoriteGames'
      },
      slugMap: {
        'RecentlyPlayed': 'recently-played',
        'RecommendedGames': 'recommended-games',
        'FavoriteGames': 'favorite-games'
      }
    }
  },
  computed: {
    groupSliderItemLimit () {
      if (!this.data) return null
      return this.setGroupSliderItemLimit(this.data, true)
    },
    filteredGames () {
      if (!this.groupSliderItemLimit) return []
      return this.filterGamesInfoDataByGroup(this.groupSliderItemLimit.gameIds)
    },
    favorites () {
      return store.getters['gap/getFavoriteGames']
    }
  },
  methods: {
    onTabChange (activeTab) {
      this.section = activeTab
      this.showHideSeeAll = true
      store.dispatch(`gap/${this.methodMap[activeTab]}`).then(response => {
        this.data = response
        this.componentKey = Math.random()
      }).catch(error => {
        console.log('casino - tab change error:', error)
      })
    },
    updateSeeAllStatus (value) {
      this.showHideSeeAll = value
    }
  },
  created () {},
  watch: {
    favorites (newVal) {
      if (newVal && this.section === 'FavoriteGames') {
        this.data = newVal
        this.componentKey = Math.random()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/igaming/partials/casinoUserGameSection.vue